import React, { useContext } from 'react';
import ReactHTMLParser from 'react-html-parser';
import { graphql } from 'gatsby';
import Helmet from 'react-helmet';
import { SecondaryHero } from '@latitude/hero';
import { Heading2 } from '@latitude/heading';
import { ALIGN } from '@latitude/core/utils/constants';
import { StickyNavigation } from '@latitude/sticky-navigation';
import Layout from '../components/layout';
import Section from '../components/Section/Section';
import PageData from '../data/pages/consumer-data-right-policy/index.json';
import { PageContext } from '@/context/PageContext';
import '../../sass/_table.scss';

const Privacy = ({ location, data }) => {
    /** Contentful Data */
    const contentfulPageData = useContext(PageContext);
    const state = contentfulPageData?.updatedBody || {};
    /** - END - */
    return (
        <Layout location={location}>
            <main className="navigation-spacer">
                <Helmet>
                    <title>{PageData.metaTitle} </title>
                    <meta name="description" content={PageData.metaDesc} />
                    <link
                        href="https://www.latitudefinancial.com.au/consumer-data-right-policy/"
                        rel="canonical"
                    />
                </Helmet>

                <SecondaryHero heading="Consumer Data Right policy" />

                <div className="d-none d-lg-block">
                    <StickyNavigation
                        items={PageData.nav}
                        offsetElem="[data-sticky-navigation-offset]"
                        {...state?.inPageNavData?.[0]}
                    />
                </div>

                <Section id="statement">
                    <div className="row">
                        <div className="col-lg-8 offset-lg-2">
                            {ReactHTMLParser(data.allMarkdownRemark.edges[0]?.node?.html)}
                        </div>
                    </div>
                </Section>
            </main>
        </Layout>
    );
};

export default Privacy;

export const query = graphql`
  query {
    allMarkdownRemark(
      filter: { fileAbsolutePath: { glob: "**/src/data/pages/consumer-data-right-policy/consumer-data-right-policy.md" } }
    ) {
      edges {
        node {
          html
          frontmatter {
            id
            title
          }
        }
      }
    }
  }
`;

